// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  backofficeUrl: "https://boapi.egitdns.net",
  globalDataApi: "http://164.160.104.123:3030",
  feedUrl: "https://ticker.egidegypt.com",
  recaptcha: {
    siteKey: "6LePCWEfAAAAAIbSbj1pSyTZp_UDG5ItAS4ReI24",
  },
};

// "backofficeUrl": "http://164.160.104.163:9090",
// "globalDataApi": "http://164.160.104.123:3030",
// "feedUrl": "http://164.160.104.163:9090"

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
